import type { IAccountEditDTO, IInvestorAnalysisData } from '@types'
import type { IStock } from '~/@types/assets'
import Api from '@api/Api'

export default abstract class UserApi {
  public static getAssetsWatching(): Promise<Array<IStock>> {
    return Api.get<Array<IStock>>('/user/assets/watching')
  }

  public static updateAvatar(data: FormData): Promise<IBooleanResponse> {
    return Api.post<IBooleanResponse>('/user/avatar', data)
  }

  public static updateUserInvestorData(data: IInvestorAnalysisData): Promise<IBooleanResponse> {
    return Api.post<IBooleanResponse>('/user/investor-data', data)
  }

  public static updateUser(data: IAccountEditDTO): Promise<IBooleanResponse> {
    return Api.post<IBooleanResponse>('/user', data)
  }
}
